var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"gestao"}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"text"},[_c('Editor',{attrs:{"contents":_vm.editor}})],1),_c('div',{staticClass:"image"},[_c('img',{attrs:{"src":_vm.image}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }